import React from 'react';
import { useNavigation } from '@react-navigation/native';

import Avatar from '@src/components/Avatar';
import { Business } from '@src/types';

import {
  BusinessAddress,
  BusinessContainer,
  BusinessName,
  BusinessWrapper,
} from './styled';
import { ScreenNavigationProp } from './types';

type Props = {
  item: Business;
};

const BusinessItem: React.FC<Props> = React.memo(({ item }) => {
  const navigation = useNavigation<ScreenNavigationProp>();

  const selectBusinessHandler = React.useCallback(() => {
    navigation.navigate('NewPost', { businessId: item.id });
  }, [item.id, navigation]);

  return (
    <BusinessContainer onPress={selectBusinessHandler}>
      <Avatar source={item.cover?.source} size={56} />
      <BusinessWrapper>
        <BusinessName>{item.name}</BusinessName>
        <BusinessAddress>{item.address}</BusinessAddress>
      </BusinessWrapper>
    </BusinessContainer>
  );
});

export default BusinessItem;
